import { defineAgenda } from '@/shared/navigation/core';

/**
 * Admin agenda správy oprávnění rolí — strom permission katalogu s úrovněmi (None/Read/Edit)
 * per role. Fáze 2 dle backend.16 §10.
 */
export const rolePermissionsAgenda = defineAgenda({
  id: 'security.role-permissions',
  path: 'security/role-permissions',
  open: {},
  state: {},
  title: 'Oprávnění rolí',
  icon: 'lock',
});
